export default __webpack_public_path__ + "static/media/Stroke 2.0d939f9b.svg";